import { useEffect, useState } from "react";
import {
  getClientIdFromUrl,
  getEnvFromUrl,
} from "../../../../utils/commonLogics";
import SurveyXmotType from "../../../../views/XMOTSurveys/ViewResults/viewResultsComponents/ResultsTab/resultsComponents/SurveyXmotType/SurveyXmotType";
import { Button } from "primereact/button";

const ExperienceCategoryXmot = ({ token, study_id }) => {
  const hostname = window.location.hostname;
  const [loading, setLoading] = useState(true);
  const [showIframeContent, setShowIframeContent] = useState(false);

  useEffect(() => {
    console.log(
      "url====>",
      `https://${getEnvFromUrl(hostname)}.qualsights.com/admin-console2/mr/ai-responses/id/${getClientIdFromUrl(hostname)}/pid/${study_id}/tab/summaryvisual/showResponseTab/1?v=1&xmot_results=1&s_view=1&env=${window.location.origin}&tstring=${token}`,
    );
  }, [hostname, study_id, token]);

  return (
    <>
      {/* <div className="d-flex align=items-center justify-content-end">
        <Button
          style={{ visibility: "hidden" }}
          className="p-0"
          link
          onClick={() => setShowIframeContent(!showIframeContent)}
        >
          {"Show Data"}
        </Button>
      </div> */}
      {showIframeContent ? (
        <div
          className="mt-4"
          style={{
            width: "100%",
            height: "65vh",
            border: "1px solid #ccc",
            position: "relative",
            paddingTop: "20px",
          }}
        >
          {/* Loader overlay */}
          {loading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#fff",
                zIndex: 10,
              }}
            >
              <div
                className="spinner-border"
                role="status"
                style={{ color: "black" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          <iframe
            // src={`https://${getEnvFromUrl(hostname)}.qualsights.com/admin-console2/mr/ai-responses/id/${getClientIdFromUrl(hostname)}/pid/${study_id}/tab/summaryvisual/showResponseTab/1?v=1&xmot_results=1&env=${window.location.origin}&tstring=${token}&xmot_session_id=${sessionId}&xmot_session_code=${sessionCode}`}
            // src={`https://development.qualsights.com/admin-console2/ai/ai-reports/id/${getClientIdFromUrl(hostname)}/pid/${study_id}/showResponseTab/1?xmot_results=1&env=${window.location.origin}&tstring=${token}&xmot_session_id=${sessionId}`}
            // src={`https://${getEnvFromUrl(hostname)}.qualsights.com/admin-console2/ai/ai-reports/id/${getClientIdFromUrl(hostname)}/pid/${study_id}/showResponseTab/1?xmot_results=1&s_view=1&env=${window.location.origin}&tstring=${token}`}
            src={`https://${getEnvFromUrl(hostname)}.qualsights.com/admin-console2/mr/ai-responses/id/${getClientIdFromUrl(hostname)}/pid/${study_id}/tab/summaryvisual/showResponseTab/1?v=1&xmot_results=1&s_view=1&env=${window.location.origin}&tstring=${token}`}
            title="Third Party Content"
            width="100%"
            height="100%"
            style={{ border: "none" }}
            allowFullScreen
            onLoad={() => setLoading(false)}
          />
        </div>
      ) : (
        <SurveyXmotType
          study_id={study_id}
          token={token}
          clientId={getClientIdFromUrl(hostname)}
        />
      )}
    </>
  );
};

export default ExperienceCategoryXmot;
